export default {"src":"/_next/static/media/holiday-promo-2023-news-icon.e6e96d9d.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};